export const DSL = {
  ALL: '全部',
  QUERY: '导出当前筛选条件下的数据',
  SELECT: '导出选中的数据',
}

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50]

export const DEFAULT_PAGE_SIZE = 10

export const STATUS_ENUM = {
  WAITING: {
    label: '排队中',
    color: 'text-primary-700',
    bgcolor: 'var(--ow-color-warning-400)',
  },
  RUNNING: {
    label: '生成中',
    color: 'text-primary-700',
    bgcolor: 'var(--ow-color-success-200)',
  },
  CANCEL: {
    label: '已取消',
    color: 'text-black',
    bgcolor: 'var(--ow-color-neutral-600)',
  },
  READY: {
    label: '文件已生成，请下载',
    color: 'text-green-700',
    bgcolor: 'var(--ow-color-success-400)',
  },
  TIMEOUT: {
    label: '生成失败',
    color: 'text-red-700',
    bgcolor: 'var(--ow-color-error-500)',
  },
  NOT_SUPPORT: {
    label: '不支持的模式',
    color: 'text-red-700',
    bgcolor: 'var(--ow-color-neutral-200)',
  },
}
